import request from "@/utils/request";

// 综合素养-评价分析-人数
export const myStudentAnalysisCount = (data) => {
  return request({
    url: "/evaluationTargetRemote/myStudentAnalysisCount",
    method: "POST",
    data,
  });
};
// 综合素养-评价分析-列表
export const myStudentAnalysisList = (data) => {
  return request({
    url: "/evaluationTargetRemote/myStudentAnalysisList",
    method: "POST",
    data,
  });
};
// 综合素养-学生分析-统计
export const analysisCount = (data) => {
  return request({
    url: "/evaluationTargetRemote/analysisCount",
    method: "POST",
    data,
  });
};
// 学校-查询所有学校及分类及年级班级
export const findAllSchoolInfoAndClass = (params) => {
  return request({
    url: "/evaluationTarget/findAllSchoolInfoAndClass",
    method: "get",
    params,
  });
};

// 综合素养-报告单
export const newFileDownload = (params) => {
  return request({
    url: "/evaluationTargetRemote/newFileDownload",
    method: "get",
    params,
  });
};
export const newFileDownload2 = (params) => {
  return request({
    url: "/evaluationTargetRemote/newFileDownload",
    method: "get",
    responseType: "blob",
    params,
  });
};

// 综合素养-查询学生列表
export const getStudentList = (data) => {
  return request({
    url: "/evaluationTargetRemote/getStudentList",
    method: "post",
    data,
  });
};
// 教师寄语
export const queryTeachercomments = (data) => {
  return request({
    url: "/evaluationTargetRemote/queryTeachercomments",
    method: "post",
    data,
  });
};
// 查询身体素质信息
export const queryPhysicalStudentDetailInfo = (data) => {
  return request({
    url: "/evaluationTargetRemote/queryPhysicalStudentDetailInfo",
    method: "post",
    data,
  });
};
// 指标评价-评价详情
export const queryEvaluationTargetScoreDetail = (data) => {
  return request({
    url: "/evaluationTargetRemote/queryEvaluationTargetScoreDetail",
    method: "post",
    data,
  });
};
